import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { getBrandImage } from '@utils/get-brand-image.ts';

import { useModals } from '@shared/contexts';

import { useQueryGetMe } from '@hooks/api/user/use-query-me.ts';

import { Button } from '@components/button';
import { ModalName } from '@components/modals/types.ts';

import { config } from '@/config.ts';

import * as Styled from './prefooter.styled.ts';

const brand = config.BRAND || 'default';
const isCom2Brand = brand === 'com2';
const isXpBrand = brand === 'ngu3' || isCom2Brand;

const Prefooter = () => {
	const { t } = useTranslation(isXpBrand ? 'prefooterXp' : 'prefooter');
	const { openModal } = useModals();
	const { data: user } = useQueryGetMe();
	const isAuthenticated = !!user?.pm_id;

	const prefooterImage = getBrandImage('prefooter');

	const handleRegisterClick = () => {
		openModal(ModalName.REGISTER);
	};

	const desc1_hg = isXpBrand
		? t('desc1_hg', { points: isCom2Brand ? 300 : isAuthenticated ? 300 : 100 })
		: t('desc1_hg');

	return (
		<Styled.Wrapper>
			<Styled.Section>
				<Styled.Group>
					<Styled.Title>
						{t('title')} <span>{t('title_hg')}</span>
					</Styled.Title>
					<Styled.DescGroup>
						<Styled.Desc>
							{t('desc1')} <span>{desc1_hg}</span> {t('desc1_end')}
						</Styled.Desc>
						{t('desc2') && (
							<Styled.Desc>
								{t('desc2')} <span>{t('desc2_hg')}</span> {t('na')} <span>{t('desc1_end_hg')}</span>
							</Styled.Desc>
						)}
					</Styled.DescGroup>
					<Styled.ButtonWrapper>
						<Button onClick={handleRegisterClick} size='large' color='primary' minWidth={104}>
							{t('begin')}
						</Button>
					</Styled.ButtonWrapper>
				</Styled.Group>
				<Styled.ImgWrapper>
					<Styled.Img src={prefooterImage} alt='Prefooter' />
				</Styled.ImgWrapper>
			</Styled.Section>
		</Styled.Wrapper>
	);
};

export default Prefooter;
